var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return (this.badgeData.time_start < _vm.currentDateTime() &&
    this.badgeData.time_stop > _vm.currentDateTime()) ||
    this.badgeData.time_set === false
    ? _c("span", {
        class: [{ bigBadge: _vm.bigBadge }, { smallBadge: _vm.smallBadge }],
        style: [
          this.badgeData.color
            ? { backgroundColor: this.badgeData.color }
            : { backgroundColor: "#f7aa10" },
        ],
        domProps: { innerHTML: _vm._s(this.badgeData.text) },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Badge.vue